import { render, staticRenderFns } from "./TkChangeDetail.vue?vue&type=template&id=1a0379a8&scoped=true&"
import script from "./TkChangeDetail.vue?vue&type=script&lang=js&"
export * from "./TkChangeDetail.vue?vue&type=script&lang=js&"
import style0 from "./TkChangeDetail.vue?vue&type=style&index=0&id=1a0379a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0379a8",
  null
  
)

export default component.exports